import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface GetDashboardCriteria {
    id: string;
}

class GetDashboardCriteriaImpl implements GetDashboardCriteria {
    constructor(readonly id: string) {}
}

export class GetDashboardCriteriaBuilder {
    private id: Option<string> = none;

    static create = (): GetDashboardCriteriaBuilder => new GetDashboardCriteriaBuilder();

    withId = (id: string): GetDashboardCriteriaBuilder => {
        this.id = some(id);
        return this;
    };

    build = (): GetDashboardCriteria => {
        if (isNone(this.id)) {
            throw new ReferenceError('Undefined prop');
        }

        return new GetDashboardCriteriaImpl(this.id.value);
    };
}
